import { Context, PoserMode } from "../../../context";

export type ActorTransition = "in" | "out" | "off" | undefined;

/**
 * handles the children of the corning
 */
export class ActorTransitioner {
  transY: number;
  transAlpha: number;

  overrideTransition?: ActorTransition;

  static globalOverrideTransition?: ActorTransition;

  static maxTransitionDeferal = 30 * 10;
  static maxInterpolationDistSq = 6 ** 2; // ft^2

  private transitionAlpha: number;
  private transitionLimitsY = [-10, 0];
  private deltaTransition = 0.01;
  private currentTransition: ActorTransition = "out";

  constructor(context: Context) {
    const intitialState =
      context.options.playbackMode === PoserMode.PLAY
        ? "off"
        : context.gameState.isLiveAction()
        ? "out"
        : "in";

    this.currentTransition = intitialState;
    this.transitionAlpha = intitialState === "off" ? 1 : 0;

    this.transY = 0;
    this.transAlpha = 0;
  }

  update(context: Context) {
    const deltaT = context.clock.delta;
    const playbackMode = context.options.playbackMode;
    const isLive = context.gameState.isLiveAction();

    const transition =
      playbackMode === PoserMode.PLAY ? "off" : isLive ? "in" : "out";

    this.set(transition);

    let deltaAlpha = 30 * deltaT * this.deltaTransition;
    switch (this.currentTransition) {
      case "in":
        this.transitionAlpha = Math.min(this.transitionAlpha + deltaAlpha, 1);
        if (this.transitionAlpha >= 1) this.currentTransition = undefined;
        break;

      case "out":
        this.transitionAlpha = Math.max(this.transitionAlpha - deltaAlpha, 0);
        if (this.transitionAlpha <= 0) this.currentTransition = undefined;
        break;

      case "off":
        this.transitionAlpha = 1;
        break;

      case undefined:
      default:
        break;
    }

    this.transAlpha = Math.min(1, Math.max(this.transitionAlpha, 0));
    this.transY =
      this.transitionLimitsY[0] * (1 - this.transAlpha) +
      this.transitionLimitsY[1] * this.transAlpha;
  }

  set(direction: ActorTransition) {
    this.currentTransition =
      ActorTransitioner.globalOverrideTransition ??
      this.overrideTransition ??
      direction;
  }
}
